import React, { Component } from 'react'
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import Fade from 'react-reveal/Fade';

import SectionTitle from '../SectionTitle/SectionTitle';
import NewsPic from '../../assets/img/news.png';

import './News.css';


export default class News extends Component {
    render() {
        return (
            <section id="news" className="section">
                <Fade duration={1000} delay={200}>
                <SectionTitle>أخبار الأكاديمية</SectionTitle>
                </Fade>


                <Fade duration={1000} delay={200}>
                    <div dir="ltr" className="mt-3">
                        <Carousel
                            autoPlay={true}
                            infiniteLoop={true}>
                            {/* <!-- Start Carousel --> */}
                            <div className="carousel-news">
                                <div className="img-overlay"></div>
                                <img src={NewsPic} alt='news' />
                                <p className="legend">
                                    برنامج يسّر يختتم دورة #إدارة_التغيير أولى دورات أكاديمية الحكومة الرقمية والذي ضم عشرة من
                                            المدراء التنفيذيين لتقنية المعلومات بالجهات الحكومية ويهدف البرنامج من خلال هذه الدورات إلى
                                            تطوير القيادات الحكومية من خلال استهداف 200 مدير تنفيذي بالجهات الحكومية وجعلهم سفراء
                                            للتغيير
                        </p>
                            </div>

                            <div className="carousel-news">
                                <div className="img-overlay"></div>
                                <img src={NewsPic} alt='news' />
                                <p className="legend">
                                    برنامج يسّر يختتم دورة #إدارة_التغيير أولى دورات أكاديمية الحكومة الرقمية والذي ضم عشرة من
                                            المدراء التنفيذيين لتقنية المعلومات بالجهات الحكومية ويهدف البرنامج من خلال هذه الدورات إلى
                                            تطوير القيادات الحكومية من خلال استهداف 200 مدير تنفيذي بالجهات الحكومية وجعلهم سفراء
                                            للتغيير
                        </p>
                            </div>
                            {/* <div className="carousel-news">
                        <div className="img-overlay"></div>
                        <img src="assets/3.jpeg" />
                        <p className="legend news-content">Legend 3</p>
                    </div> */}

                            {/* <!-- End Carousel --> */}
                        </Carousel>
                    </div>
                </Fade>
            </section>
        )
    }
}
